var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateQuestionGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 0L14.9879 2.06069L17.0486 3.15972L14.9879 4.25876L13.8889 6.31945L12.7898 4.25876L10.7292 3.15972L12.7898 2.06069L13.8889 0ZM6.38889 2.60417L8.6111 6.77083L12.7778 8.99304L8.6111 11.2153L6.38889 15.382L4.16666 11.2153L0 8.99304L4.16666 6.77083L6.38889 2.60417ZM16.1111 12.6042L14.7223 10L13.3333 12.6042L10.7292 13.993L13.3333 15.382L14.7223 17.9861L16.1111 15.382L18.7153 13.993L16.1111 12.6042Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateQuestionGreen);
export default __webpack_public_path__ + "static/media/generate-question-green.796468c1baecbdae6432c06cfb60b9d1.svg";
export { ForwardRef as ReactComponent };